/**
 * Вывод шильдиков в карточке товара
 *
 * @package citrus.vue.product.favorites
 */

import {Vue} from "ui.vue";
import app from './components/App.vue';

Vue.component('CitrusProductFavorites', app);